/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelSummary } from './HotelSummary';
import {
    HotelSummaryFromJSON,
    HotelSummaryFromJSONTyped,
    HotelSummaryToJSON,
    HotelSummaryToJSONTyped,
} from './HotelSummary';

/**
 * Response to the /hotel/{hotel_id}/similar
 * @export
 * @interface SimilarHotelsResponse
 */
export interface SimilarHotelsResponse {
    /**
     * 
     * @type {Array<HotelSummary>}
     * @memberof SimilarHotelsResponse
     */
    results?: Array<HotelSummary>;
}

/**
 * Check if a given object implements the SimilarHotelsResponse interface.
 */
export function instanceOfSimilarHotelsResponse(value: object): value is SimilarHotelsResponse {
    return true;
}

export function SimilarHotelsResponseFromJSON(json: any): SimilarHotelsResponse {
    return SimilarHotelsResponseFromJSONTyped(json, false);
}

export function SimilarHotelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarHotelsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(HotelSummaryFromJSON)),
    };
}

export function SimilarHotelsResponseToJSON(json: any): SimilarHotelsResponse {
    return SimilarHotelsResponseToJSONTyped(json, false);
}

export function SimilarHotelsResponseToJSONTyped(value?: SimilarHotelsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(HotelSummaryToJSON)),
    };
}

